import { SC } from "../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const reportService = {
    getOrdersWithStatus,
    getVideoShipments,
    getTodaysShipments,
    getWebLog,
    getOrderLog,
    getAccessLog,
    getOrderBooking,
    getForcastReport,
    getReceivingReports,
    getUCDReached,
    getContactLog,
    checkOrderStatusWithBarcode,
    createLabelWithBarcode,
    getEditingReports,
    getProductionReports,
    getRecetlyReceivedOrders,
    getOrderOnHoldList,
    saveVideoCount,
    getMozaixPrintedReports,
    getQaReports,
    getReceivingReportsWtk,
    getRecetlyReceivedOrdersWtk,
    getUCDReachedWtk
};

function getOrdersWithStatus(status, value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall(`getOrdersWithStatus/${pathSegment(status)}/${pathSegment(value)}`, {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getVideoShipments(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('videoShipmentsReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getTodaysShipments(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('todayShipmentsReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getWebLog(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('webLogReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
        order_id: value,
    });
}

function getContactLog(fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('contactLogReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getAccessLog(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('accessLogReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getOrderBooking(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('ordersBookingReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getForcastReport(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('ordersForcastReport', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

function getUCDReached(numOfDays, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('ucdReachedButNotProduced', {
        numOfDays,
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}

//
function getReceivingReports(data) {
    return SC.postCall(`ordersUploadPhotosVideoProduction`, data);
}

function getOrderOnHoldList(data) {
    return SC.postCall(`getOrderOnHoldList`, data);
}
function getRecetlyReceivedOrders(data) {
    return SC.postCall(`getRecetlyReceivedOrders`, data);
}

function getEditingReports(data) {
    return SC.postCall(`getEditingReports`, data);
}

function getProductionReports(data) {
    return SC.postCall(`getProductionReports`, data);
}

function checkOrderStatusWithBarcode(data) {
    return SC.postCall('receiveOrderByBarcode', data);
}

function createLabelWithBarcode(data) {
    return SC.postCall('orderFoundByBarcode', data);
}

function saveVideoCount(data) {
    return SC.postCall('saveVideoCount', data);
}


function getOrderLog(value, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('getOrderActivityLog', {
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
        order_id: value,
    });
}

function getQaReports(data) {
    return SC.postCall(`getQaReports`, data);
}

function getMozaixPrintedReports(data) {
    return SC.postCall(`getMozaixPrintedReports`, data);
}

function getReceivingReportsWtk(data) {
    return SC.postCall(`ordersUploadPhotosVideoProductionWtk`, data);
}

function getRecetlyReceivedOrdersWtk(data) {
    return SC.postCall(`getRecetlyReceivedOrdersWtk`, data);
}

function getUCDReachedWtk(numOfDays, fromDate, toDate, page, pageSize, sorted) {
    return SC.getCall('ucdReachedButNotProducedWtk', {
        numOfDays,
        from: fromDate,
        to: toDate,
        page,
        pageSize,
        sort: sorted,
    });
}
